/**
 * Built-in label utilities - extracted to break circular dependency
 * between labelTools.ts and docGetLabelTable.ts
 */
import type { BuiltInLabel, LabelableEntityBase } from "building-types/entities/labelTypes";
import { BuiltInLabels } from "building-types/entities/labelTypes";

export function isBuiltInLabel(label: string): label is BuiltInLabel {
  return BuiltInLabels.includes(label as BuiltInLabel);
}

/**
 * @deprecated
 * Provides type safety when checking if an entity contains a built-in label.
 *
 * TODO: remove this function when switching to a fully generalized filtering system.
 */
export function entityContainsBuiltInLabels(entity: LabelableEntityBase, ...labels: BuiltInLabel[]): boolean {
  return labels.some((label) => entity.labels[label]);
}
